/**
 * Created by bikuAdmin on 2018/8/4.
 */
function browser() {
  let ua;
  try {
    ua = navigator.userAgent.toLowerCase();
    console.log(ua)
  } catch (e) {
    console.log(e)
  }
  // 判断是否在app中打开网页
  if (ua.match(/micromessenger/i)) {
    return 'weixin'
  } else if (ua.match(/weibo/i)) {
    return 'weibo';
  } else if (ua.match(/qq\/\d/i)) {
    return 'qq'
  } else if (ua.match(/biku/)) {
    return 'biku'
  }else {
    return false;
  }
}

function androidOriOS () {
  let ua;
  try {
    ua = navigator.userAgent.toLowerCase();
  } catch (e) {
    console.log(e)
  }

  if (ua.match(/android/)) {
    return 'android'
  } else if (ua.match(/iphone|ipad|ipod/)) {
    return 'ios'
  }else {
    return false
  }
}


export {browser, androidOriOS};
